import { AppLayout } from '@/components/layout/AppLayout'
import { EnrolledLanguagesList } from '@/components/dashboard/EnrolledLanguagesList'
import { NoLanguagesEmptyState } from '@/components/languages/NoLanguagesEmptyState'
import { useLanguages } from '@/hooks/useLanguages'
import { PageContainer } from '@/components/layout/PageContainer'

export default function Dashboard() {
  const { languages, loading, selectedLanguageId } = useLanguages()
  const enrolled = languages.filter((l) => l.enrolled)
  const activeId =
    enrolled.find((l) => l.id === selectedLanguageId)?.id ?? enrolled[0]?.id ?? null

  return (
    <AppLayout>
      <PageContainer className="py-12 sm:py-16 lg:py-20">
        <h1 className="animate-enter font-display text-3xl sm:text-4xl text-heading leading-tight mb-10">
          Your languages
        </h1>
        {loading && <DashboardSkeleton />}
        {!loading && enrolled.length === 0 && <NoLanguagesEmptyState />}
        {!loading && enrolled.length > 0 && (
          <EnrolledLanguagesList languages={enrolled} activeId={activeId} />
        )}
      </PageContainer>
    </AppLayout>
  )
}

/** Skeleton matching ~3 enrolled rows — never an empty container while loading. */
function DashboardSkeleton() {
  return (
    <div data-testid="dashboard-skeleton" className="border-t border-line-soft" aria-hidden="true">
      {[0, 1, 2].map((i) => (
        <div key={i} className="flex items-center gap-4 min-h-[56px] py-4 border-b border-line-soft">
          <span className="h-4 w-6 rounded bg-surface-bg animate-pulse" />
          <span className="flex flex-col gap-1.5">
            <span className="h-5 w-32 rounded bg-surface-bg animate-pulse" />
            <span className="h-3 w-20 rounded bg-surface-bg animate-pulse" />
          </span>
        </div>
      ))}
    </div>
  )
}
